import {FC, useState} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {useSelector} from 'react-redux'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import {toAbsoluteUrl} from '../../../../helpers'
import {RootState} from '../../../../../app/redux/store'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  path?: string
  isSub?: boolean
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  path,
  isSub = false, //isSubMenu
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const [page, setPage] = useState(pathname)
  const {app} = config
  const agentSlice = useSelector((state: RootState) => state.agent)

  return (
    <div className={clsx('menu-item',{'menu-disable' : agentSlice.newTnc === true})}>
      <Link className={clsx('menu-link without-sub', {active: isActive, 'menu-is-sub': isSub})} to={to}>
        <div className='menu-select'>
          {!isSub && <svg xmlns="http://www.w3.org/2000/svg" width="5" height="36" viewBox="0 0 5 36">
            <path id="Rectangle_935" data-name="Rectangle 935" d="M0,0H0A5,5,0,0,1,5,5V31a5,5,0,0,1-5,5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z" fill="#f09108" />
          </svg>}
        </div>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {' '}
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {path && (
          <span className='menu-icon'>
            {' '}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='22.414'
              height='20'
              viewBox='0 0 22.414 20'
            >
              {path === 'dashboard' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_2338'
                  data-name='Path 2338'
                  d='M4110,2220.255h7m-7-7v14m-3.267-14h6.533a5.8,5.8,0,0,1,2.459.254,2.34,2.34,0,0,1,1.02,1.02,5.784,5.784,0,0,1,.255,2.459v6.533a5.786,5.786,0,0,1-.255,2.459,2.34,2.34,0,0,1-1.02,1.019,5.8,5.8,0,0,1-2.459.254h-6.533a5.792,5.792,0,0,1-2.459-.254,2.34,2.34,0,0,1-1.02-1.019,5.786,5.786,0,0,1-.255-2.459v-6.533a5.784,5.784,0,0,1,.255-2.459,2.34,2.34,0,0,1,1.02-1.02A5.792,5.792,0,0,1,4106.733,2213.255Z'
                  transform='translate(-4102.25 -2212.505)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              )}
              {path === 'myprofile' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_10172'
                  data-name='Path 10172'
                  d='M6172.825,211.514a3.1,3.1,0,0,1,2.854-1.889h4.65a3.1,3.1,0,0,1,2.855,1.889m-2.08-7.7a3.1,3.1,0,1,1-3.1-3.1A3.1,3.1,0,0,1,6181.1,203.813Zm4.65,1.938A7.75,7.75,0,1,1,6178,198,7.75,7.75,0,0,1,6185.755,205.75Z'
                  transform='translate(-6169.505 -197.25)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              )}
              {path === 'newpropertyrequest' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_2343'
                  data-name='Path 2343'
                  d='M3221.9,2821.523a6.227,6.227,0,0,1,1.466.084,2.477,2.477,0,0,1,1.751,1.751,6.209,6.209,0,0,1,.084,1.466v7.593a6.153,6.153,0,0,1-.27,2.609,2.481,2.481,0,0,1-1.082,1.082,6.151,6.151,0,0,1-2.61.27h-5.282a6.15,6.15,0,0,1-2.61-.27,2.48,2.48,0,0,1-1.082-1.082,6.148,6.148,0,0,1-.27-2.609v-7.593a6.209,6.209,0,0,1,.084-1.466,2.478,2.478,0,0,1,1.751-1.751,6.227,6.227,0,0,1,1.466-.084m.825,9.079,1.651,1.651,3.714-3.714m-4.87-5.365h3.962a2.055,2.055,0,0,0,.87-.09.828.828,0,0,0,.361-.361,2.053,2.053,0,0,0,.09-.87v-.66a2.053,2.053,0,0,0-.09-.87.828.828,0,0,0-.361-.361,2.055,2.055,0,0,0-.87-.09h-3.962a2.053,2.053,0,0,0-.87.09.827.827,0,0,0-.361.361,2.053,2.053,0,0,0-.09.87v.66a2.053,2.053,0,0,0,.09.87.827.827,0,0,0,.361.361A2.053,2.053,0,0,0,3216.622,2823.173Z'
                  transform='translate(-3211.25 -2819.122)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              )}
              {path === 'myproperties' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_2339'
                  data-name='Path 2339'
                  d='M74.556,805.222h3.733a3.865,3.865,0,0,1,1.64.17,1.56,1.56,0,0,1,.68.68,3.865,3.865,0,0,1,.17,1.64V813m-6.222,0V801.489a3.865,3.865,0,0,0-.17-1.64,1.56,1.56,0,0,0-.68-.68,3.865,3.865,0,0,0-1.64-.17h-2.8a3.865,3.865,0,0,0-1.64.17,1.56,1.56,0,0,0-.68.68,3.865,3.865,0,0,0-.17,1.64V813m14.778,0H66m3.5-10.889h2.333M69.5,805.222h2.333M69.5,808.333h2.333'
                  transform='translate(-65.25 -798.25)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              )}
              {path === 'mygrouplisting' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id="Path_10218"
                  data-name="Path 10218"
                  d="M6458.41,453.539v-1.616a3.233,3.233,0,0,0-2.424-3.129m-2.827-9.56a3.232,3.232,0,0,1,0,5.992m1.212,8.313a8.084,8.084,0,0,0-.245-2.852,3.232,3.232,0,0,0-1.749-1.749,8.073,8.073,0,0,0-2.853-.246H6447.1a8.073,8.073,0,0,0-2.853.246,3.23,3.23,0,0,0-1.748,1.749,8.054,8.054,0,0,0-.246,2.852m9.289-11.308a3.231,3.231,0,1,1-3.23-3.231A3.231,3.231,0,0,1,6451.544,442.231Z"
                  transform="translate(-6441.505 -438.25)"
                  fill="none"
                  stroke='#bcbcc4'
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                />
              )}
              {path === 'newpropertyrequest' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_2343'
                  data-name='Path 2343'
                  d='M3221.9,2821.523a6.227,6.227,0,0,1,1.466.084,2.477,2.477,0,0,1,1.751,1.751,6.209,6.209,0,0,1,.084,1.466v7.593a6.153,6.153,0,0,1-.27,2.609,2.481,2.481,0,0,1-1.082,1.082,6.151,6.151,0,0,1-2.61.27h-5.282a6.15,6.15,0,0,1-2.61-.27,2.48,2.48,0,0,1-1.082-1.082,6.148,6.148,0,0,1-.27-2.609v-7.593a6.209,6.209,0,0,1,.084-1.466,2.478,2.478,0,0,1,1.751-1.751,6.227,6.227,0,0,1,1.466-.084m.825,9.079,1.651,1.651,3.714-3.714m-4.87-5.365h3.962a2.055,2.055,0,0,0,.87-.09.828.828,0,0,0,.361-.361,2.053,2.053,0,0,0,.09-.87v-.66a2.053,2.053,0,0,0-.09-.87.828.828,0,0,0-.361-.361,2.055,2.055,0,0,0-.87-.09h-3.962a2.053,2.053,0,0,0-.87.09.827.827,0,0,0-.361.361,2.053,2.053,0,0,0-.09.87v.66a2.053,2.053,0,0,0,.09.87.827.827,0,0,0,.361.361A2.053,2.053,0,0,0,3216.622,2823.173Z'
                  transform='translate(-3211.25 -2819.122)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              )}
              {path === 'myguidance' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id='Path_2341'
                  data-name='Path 2341'
                  d='M3560,2930.159s.791-.792,3.165-.792,3.956,1.583,6.33,1.583,3.165-.791,3.165-.791v-9.5s-.791.792-3.165.792-3.956-1.583-6.33-1.583-3.165.791-3.165.791V2935.7'
                  transform='translate(-3558.938 -2919.122)'
                  fill='none'
                  stroke='#bcbcc4'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                />
              )}
              {path === 'termsofuse' && (
                <path
                  className='custom-svg'
                  xmlns='http://www.w3.org/2000/svg'
                  id="Path_9220" 
                  data-name="Path 9220" 
                  d="M2404.276,2780.1v3.418a2.058,2.058,0,0,0,.09.872.83.83,0,0,0,.362.362,2.053,2.053,0,0,0,.872.09h3.418m-4.742,7.448h-4.966m6.621-3.31h-6.621m9.931-2.493v5.969a6.17,6.17,0,0,1-.271,2.617,2.488,2.488,0,0,1-1.085,1.085,6.168,6.168,0,0,1-2.617.271h-5.3a6.168,6.168,0,0,1-2.617-.271,2.489,2.489,0,0,1-1.085-1.085,6.17,6.17,0,0,1-.271-2.617v-8.607a6.171,6.171,0,0,1,.271-2.617,2.493,2.493,0,0,1,1.085-1.085,6.173,6.173,0,0,1,2.617-.271h2.658a5.3,5.3,0,0,1,1.2.069,2.487,2.487,0,0,1,.717.3,5.322,5.322,0,0,1,.895.8l2.638,2.638a5.309,5.309,0,0,1,.8.895,2.48,2.48,0,0,1,.3.718A5.3,5.3,0,0,1,2409.242,2786.483Z" 
                  transform="translate(-2395.25 -2779.122)" 
                  fill="none" 
                  stroke='#bcbcc4'
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="1.5"
                />
              )}
              {path === 'packagesubscribe' && (
                <path
                  className='custom-svg'
                  xmlns="http://www.w3.org/2000/svg"
                  d="M1.27148 5.46098L8.98074 10.0392M1.27148 5.46098V14.4609L8.98074 19M1.27148 5.46098L3.53206 4.15289M8.98074 10.0392V19M8.98074 10.0392L11.3859 8.61788M16.728 5.46098V14.4609L8.98074 19M16.728 5.46098L8.98074 1L6.49817 2.43654M16.728 5.46098L14.2365 6.93332M3.53206 4.15289L11.3859 8.61788M3.53206 4.15289L6.49817 2.43654M11.3859 8.61788L14.2365 6.93332M11.3859 8.61788V11.8661L12.834 10.0392L14.2365 10.2882V6.93332M14.2365 6.93332L6.49817 2.43654"
                  fill="none"
                  stroke="#bcbcc4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.3"
                />
              )}
              {path === 'paymenthistory' && (
                <path
                  className='custom-svg'
                  xmlns="http://www.w3.org/2000/svg"
                  d="M3.43213 3.42663L2.38623 2.38079C1.92173 1.91631 1.125 2.24544 1.125 2.90063V6.2873C1.125 6.69641 1.45415 7.02554 1.86328 7.02554H5.25015C5.90845 7.02554 6.2376 6.22886 5.7731 5.76438L4.82563 4.81698C5.89307 3.74961 7.36963 3.08827 9 3.08827C12.2607 3.08827 14.9062 5.73362 14.9062 8.99418C14.9062 12.2547 12.2607 14.9001 9 14.9001C7.74492 14.9001 6.58213 14.5094 5.62544 13.8419C5.17939 13.5313 4.56724 13.6389 4.25347 14.085C3.9397 14.531 4.05044 15.1431 4.49648 15.4568C5.77617 16.3458 7.32964 16.8687 9 16.8687C13.3497 16.8687 16.875 13.3436 16.875 8.99418C16.875 4.64472 13.3497 1.11963 9 1.11963C6.82515 1.11963 4.8564 2.00244 3.43213 3.42663ZM9 5.0569C8.59087 5.0569 8.26172 5.38604 8.26172 5.79514V8.99418C8.26172 9.19104 8.33862 9.37868 8.47705 9.5171L10.6919 11.7318C10.9811 12.021 11.4486 12.021 11.7347 11.7318C12.0208 11.4427 12.0239 10.9751 11.7347 10.6891L9.7352 8.68966V5.79514C9.7352 5.38604 9.40605 5.0569 8.99692 5.0569H9Z"
                  fill="#bcbcc4"
                  stroke="#bcbcc4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0.1"
                />
              )}
              {path === 'contact' && (
                <path
                  className='custom-svg'
                  xmlns="http://www.w3.org/2000/svg"
                  d="M6.21834 3.79623C6.4308 4.48226 6.53519 5.06115 6.47295 5.22254C6.42295 5.3522 6.26302 5.46043 6.05633 5.57363M6.21834 3.79623C5.79919 2.44283 4.95944 0.672501 4.14878 0.868473C1.92832 1.40525 0.788887 4.24063 1.03236 6.1288C1.40167 8.99288 1.93893 9.5278 2.97213 11.2251C4.42295 13.6085 5.47072 16.1723 8.82702 17.0299C10.4332 17.4404 12.4728 16.6531 12.8049 16.2841C13.137 15.9152 13.1902 15.0287 12.146 13.5371C11.1953 12.179 10.9827 11.9147 10.4229 11.9147C9.68475 11.9147 9.18752 12.4805 8.2925 12.7416C7.53801 12.9616 6.92683 12.2067 5.60139 9.95551C4.49458 8.07562 4.03594 7.67515 4.77758 6.4957C5.06626 6.0366 5.65115 5.79555 6.05633 5.57363M6.21834 3.79623C9.9058 3.79623 17.2276 3.79623 17.8962 3.79623C18.2846 3.79623 18.6536 3.96684 18.7759 4.13989M14.0332 13.6483C15.3226 13.6483 17.5543 13.6483 17.9746 13.6483C18.4999 13.6483 19 13.2636 19 12.8464C19 12.4292 19 5.41078 19 4.97795C19 4.59276 18.9168 4.33924 18.7759 4.13989M18.7759 4.13989L13.313 8.6328C12.8276 9.0534 12.0703 9.7393 11.514 9.7393C10.9577 9.7393 10.3298 9.11164 9.43676 8.32868L6.05633 5.57363"
                  fill="none"
                  stroke="#bcbcc4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.3"
                />
              )}
            </svg>
          </span>
        )}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className={clsx('menu-title',{'disable' : agentSlice.newTnc === true})}>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
